export function userAdvertHelper() {
  const dispatchEventAdvertSlotReady = () => {
    window.dispatchEvent(
      new CustomEvent('anzu.gallery.advertSlotReady', {
        detail: {
          slotName: 'side',
          elementSelector: '.anz-gallery-side',
        },
      })
    )
  }

  return {
    dispatchEventAdvertSlotReady,
    adSlotClass: 'ad-position anz-gallery-side',
  }
}
